export const routes = {
	root: '/',
	publicProfile: '/user/:userId/*',
	quickLaunch: '/home',
	displayPinPreferences: '/display-pin-preferences',

	email: {
		root: '/email',
		verify: '/email/verify',
		verified: '/email/verified'
	},

	garage: {
		root: '/garage/*',
		add: '/add/:step?/*',
		edit: '/edit/:rvId/*',
		public: '/user/:userId/*/garage',
		congratulations: '/congratulations'
	},

	notifications: {
		root: '/notifications',
		settings: '/notifications/:name'
	},

	password: {
		reset: '/password/reset',
		update: '/password/update'
	},

	phone: {
		root: '/phone',
		verify: '/phone/verify',
		verified: '/phone/verified'
	},

	photo: {
		profile: '/photo/profile',
		banner: '/photo/banner'
	},

	publicProfileEdit: '/user/:userId/*/edit/:page?',

	register: {
		root: '/register',
		profile: '/register/profile',
		verify: '/register/verify',
		success: '/register/success'
	},

	login: {
		otp: '/login/otp',
		password: '/login/password' // gitleaks:allow - route path, not a secret
	},

	settings: '/settings',
	termsOfService: '/terms-of-service',
	profileUnitsOfMeasurement: '/units-of-measurement',
	campingPreferences: '/camping-preferences',
	manageConnectedAccounts: '/connected-accounts',
	loginDetailsAndSecurity: '/login-details-and-security',
	deleteAccountConfirmation: '/delete-account-confirmation',
	edit: '/edit'
} as const;

export const authRoutes = {
	loggedIn: [routes.password.reset, routes.register.verify, routes.register.success],
	loggedOut: [
		routes.password.reset,
		routes.root,
		routes.register.root,
		routes.register.profile,
		routes.login.otp,
		routes.login.password
	]
};

export const settingsRoutes = {
	loggedIn: [
		routes.settings,
		routes.notifications.root,
		routes.notifications.settings,
		routes.phone.root,
		routes.phone.verify,
		routes.phone.verified,
		routes.photo.profile,
		routes.photo.banner,
		routes.password.update,
		routes.termsOfService,
		routes.email.root,
		routes.email.verify,
		routes.email.verified,
		routes.publicProfile,
		routes.publicProfileEdit,
		routes.quickLaunch,
		routes.profileUnitsOfMeasurement,
		routes.campingPreferences,
		routes.displayPinPreferences,
		routes.edit,
		routes.manageConnectedAccounts,
		routes.loginDetailsAndSecurity,
		routes.deleteAccountConfirmation
	],
	// loggedOut: [routes.email.verified, routes.publicProfile]
	loggedOut: [routes.email.verified]
};

export const garageRoutes = {
	loggedIn: [
		`${routes.garage.add}/onboarding`,
		routes.garage.add,
		routes.garage.root,
		routes.garage.edit,
		routes.garage.public,
		routes.garage.congratulations
	],
	loggedOut: []
};
